export const UserAccountType = {
  USER: 'user',
  ADMIN: 'admin',
}
